// Public APIs and DOM measurements continue to use physical CSS pixels.
export function scaleRemSize(baselinePixels, viewportWidth) {
  const pixels = (baselinePixels * Math.min(viewportWidth, 750)) / 375;
  return Math.ceil(pixels * 100 - 1e-10) / 100;
}

export function initRemAdaptation() {
  const root = document.documentElement;
  const update = () => {
    const width = root.clientWidth || window.innerWidth;
    if (width > 0) root.style.fontSize = `${Math.min(width, 750) / 10}px`;
  };
  const restore = () => {
    if (document.visibilityState === "visible") update();
  };

  update();
  window.addEventListener("resize", update);
  window.addEventListener("orientationchange", update);
  window.addEventListener("pageshow", update);
  document.addEventListener("visibilitychange", restore);

  return () => {
    window.removeEventListener("resize", update);
    window.removeEventListener("orientationchange", update);
    window.removeEventListener("pageshow", update);
    document.removeEventListener("visibilitychange", restore);
  };
}
